<div class="availaility">

  <table class="col-md-12 work-schedule-table bottom-gap">
    <tbody>
      <tr *ngFor="let item of getArray.controls;let i = index;" style="height: 50px;">
        <td class="">
          <mat-chip-list class="example-chip">
            <mat-chip class="example-box">
              <span style="font-size: 12px;">{{item.value.day | DynamicFieldMasterTitle : days : []}}</span>
            </mat-chip>
          </mat-chip-list>
        </td>
        <!-- <td class="text-center" *ngFor="let type of types">
          <button class="btn btn-info btn-sm btn-radius specifybtn" (click)="setType(i,type.code)"
            [ngClass]="{'success-btn-custom': type.code == item.value.is_availability}" [disabled]="readonly">
            {{type.title}}
          </button>
        </td> -->

        <td class="text-centear">
          <div class="btn-group btn-group-sm">
            <button type="button" class="btn btn-sm btn-default border" *ngFor="let type of types"
              (click)="setType(i,type.code)" [ngClass]="{'success-btn-custom': type.code == item.value.is_availability}"
              [disabled]="readonly">{{type.title}}
            </button>
          </div>
        </td>

        <td class="text-center font-small">
          <ngb-timepicker [(ngModel)]="time_from[i]" (ngModelChange)="change($event,i)"  [meridian]="true" [size]="'small'"
            *ngIf="item.value.is_availability == 3" [spinners]="false" [disabled]="readonly">
          </ngb-timepicker>

          <!-- <div *ngIf="time_from&&time_from[i] && time_from[i].hour>=0 && time_from[i].hour!=null && readOnlyToggle[i]">
            {{ time_from[i].hour > 12 ? (time_from[i].hour - 12 == 0 ? '12' : time_from[i].hour - 12) : time_from[i].hour == 0 ?'12' : time_from[i].hour }}
            : {{time_from[i].minute}} {{time_from[i].hour >= 12 ? 'PM' : 'AM'}}
          </div>  && !readOnlyToggle[i]-->
        </td>

        <td class="text-center font-small">
          <ngb-timepicker [(ngModel)]="time_to[i]" (ngModelChange)="change($event,i)" [meridian]="true" [size]="'small'"
            *ngIf="item.value.is_availability == 3" [spinners]="false" [disabled]="readonly">
          </ngb-timepicker>
          <!-- <div *ngIf="time_to &&time_to[i] && time_to[i].hour>=0 &&time_to[i].hour!=null && readOnlyToggle[i]">
            {{time_to[i].hour > 12 ?( time_to[i].hour - 12 == 0 ? '12' : time_to[i].hour - 12) : time_to[i].hour == 0 ? '12' : time_to[i].hour }}
            : {{time_to[i].minute}}
            {{time_to[i].hour >= 12 ? 'PM' : 'AM'}}
          </div>   && !readOnlyToggle[i]-->
        </td>
        <!-- <td class="text-center">
          <button class="btn btn-sm btn-warning btn-xs btn-radius" style="width: 80px;"
            *ngIf="item.value.is_availability == 3 && !readOnlyToggle[i]" (click)="makeReadOnly(i)">
            <i class="fa fa-ban" aria-hidden="true"></i>&nbsp;Set
          </button>
        </td> -->
      </tr>
    </tbody>
  </table>
</div>